import { render, staticRenderFns } from "./InactiveAffinityOfferRoute.vue?vue&type=template&id=257e2f54&scoped=true&"
import script from "./InactiveAffinityOfferRoute.vue?vue&type=script&lang=js&"
export * from "./InactiveAffinityOfferRoute.vue?vue&type=script&lang=js&"
import style0 from "./InactiveAffinityOfferRoute.vue?vue&type=style&index=0&id=257e2f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e2f54",
  null
  
)

export default component.exports